import {filter, map, shareReplay} from 'rxjs/operators';
import {wsLogin$} from '@/user/auth-ws';
import {toWsMsg$, wsMsg$} from '@/ws';

wsLogin$.subscribe(() => toWsMsg$.next({method: 'service.subscribe', params: ['service.contract-biz']}));

export interface PayLoad {
  data: string[];
  eventTime: number;
  eventType: 'tpslMode' | 'closePosition' | 'airdropPosition';
}

interface WsMsg {
  uid: number;
  pushType: string;
  msgType: string;
  payload: PayLoad[];
}

export const contractBiz$ = wsMsg$.pipe(
  filter((o: WsMsg) => o.msgType === 'service.contract-biz' && o.payload.length > 0),
  map((o: WsMsg) => o.payload),
  shareReplay(1)
);
